import React from 'react';
import { CTAButton } from './CTAButton';
export function PainPoints() {
  return <section className="bg-brand-black text-white py-16 px-4 sm:px-6" data-id="element-181">
      <div className="max-w-3xl mx-auto space-y-10" data-id="element-182">
        <div className="text-center space-y-4" data-id="element-183">
          <span className="text-brand-yellow text-5xl block mb-4" data-id="element-184">⚠️</span>
          <h2 className="font-archivo text-3xl sm:text-4xl md:text-5xl uppercase" data-id="element-185">
            Este kit es para vos si sentís que…
          </h2>
        </div>

        <div className="bg-white/5 rounded-2xl p-6 sm:p-8 border border-white/10" data-id="element-186">
          <ul className="space-y-5 text-lg sm:text-xl font-medium" data-id="element-187">
            <li className="flex items-start gap-4" data-id="element-188">
              <span className="text-brand-red text-2xl shrink-0 mt-0.5" data-id="element-189">
                ❌
              </span>
              <span data-id="element-190">
                No sabés cómo estimular a tu hijo sin recurrir a pantallas
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-191">
              <span className="text-brand-red text-2xl shrink-0 mt-0.5" data-id="element-192">
                ❌
              </span>
              <span data-id="element-193">
                Querés compartir tiempo de calidad, pero no sabés qué hacer
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-194">
              <span className="text-brand-red text-2xl shrink-0 mt-0.5" data-id="element-195">
                ❌
              </span>
              <span data-id="element-196">Te preocupa verlo aburrido o poco estimulado</span>
            </li>
            <li className="flex items-start gap-4" data-id="element-197">
              <span className="text-brand-red text-2xl shrink-0 mt-0.5" data-id="element-198">
                ❌
              </span>
              <span data-id="element-199">Sentís que gastás dinero en juguetes que duran poco</span>
            </li>
            <li className="flex items-start gap-4" data-id="element-200">
              <span className="text-brand-red text-2xl shrink-0 mt-0.5" data-id="element-201">
                ❌
              </span>
              <span data-id="element-202">Querés que aprenda de forma natural, sin presión</span>
            </li>
            <li className="flex items-start gap-4" data-id="element-203">
              <span className="text-brand-red text-2xl shrink-0 mt-0.5" data-id="element-204">
                ❌
              </span>
              <span data-id="element-205">
                Terminás usando la TV o el celular porque no tenés tiempo
              </span>
            </li>
          </ul>
        </div>

        <div className="text-center bg-brand-yellow text-brand-black p-6 rounded-xl font-bold text-xl sm:text-2xl shadow-lg" data-id="element-206">
          👉 Si te pasa aunque sea una de estas cosas, este kit fue creado para
          vos.
        </div>

        <div className="pt-6" data-id="element-207">
          <CTAButton text="👉 SÍ, QUIERO TRANSFORMAR LAS TARDES EN CASA" color="red" data-id="element-208" />
        </div>
      </div>
    </section>;
}